<template>
  <div>

    <!-- <button v-if="watching === null" class="button"> </button> -->
    <button v-if="obj.watching === false" class="button is-primary" @click="watchToggle">Alert Me</button>
    <button v-if="obj.watching === true" class="button" @click="watchToggle">Watching</button>

  </div>
</template>

<script>
import Api from '@/config/Api'; // MCH added


export default {
    props: ['item'],
    data () {
      return {
        //obj: {},
        //maxPrice: 'Any price', // selected dropdown value
        //isHidden: true,
      }
    },
    /* created: function() {
      this.obj = this.item;
    },*/
    computed: {
        obj() {
          return this.item;
        }
    },
    methods: {
        watchToggle() {
          console.log("CHANGE BUTTON TO DISABLED SPINNER"); // ref: https://bulma.io/documentation/elements/button/
          
          console.log("watch?", !this.obj.watching);
          console.log("item id", this.obj._id);

          var options = {        
            watch: !this.obj.watching
          }
          if (this.obj.hasOwnProperty('products')) { // because only productGroups have 'products' property
            options.productGroupId = this.obj._id;
          } else {
            options.productId = this.obj._id;
          }
          Api().put('/api/user/watchToggle', options)
          .then(response => {
            this.obj.watching = !this.obj.watching;
            if (this.obj.watching) {
              this.$swal('Watching', `We'll let you know when it's in stock`, 'success');
            } else {
              this.$swal('Unwatching', `You'll no longer receive alerts for this product`, 'success');              
              this.obj.maxPrice = null;
              //this.$parent.$emit('refreshMaxprice');
            }
          })
          .catch((error) => {
            console.log("errrr:",error);
            const message = error.response.data.message;
            this.$swal('Oh oo!', `${message}`, 'error');
          });
        }
    }
}
</script>

<style scoped>

.no-outline {
    border-color: white !important;
    background-color: white !important;
}
.no-gap .control {
    margin-right: 0 !important;
}   
.no-gap span {
    padding-left: 0;
    padding-right: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/cards/AlertMeButton.vue